
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { JsonLdReview } from '@components/config/SEO';
import AboutUs from '@pages/about-us/Index';
import { NextSeo } from 'next-seo';

export default function Index() {
  return (
    <div>
      <NextSeo
        title="About Us | 247 Radio Carz"
        description="Based in Acocks Green, Birmingham, 24/7 Radio Carz is run by a team of friendly people whose mission it is to provide safe, reliable and comfortable taxis in Birmingham. If you need a ride, and you want it the easy way – choose us!."
        openGraph={{
          url: 'https://www.247radiocarz.co.uk/about-us',
        }}
        canonical="https://www.247radiocarz.co.uk/about-us"
      />
      <JsonLdReview />
      <AboutUs />
    </div>
  );
}
